<template>
  <div class="loginDiv">
    <div class="loginTop">
      <img src="../../../static/images/main/loginLogo.png" />
    </div>
    <div class="loginMain">
      <div class="leftDx">
        <img src="../../../static/images/main/loginLeftImg.png" class="dx" />
      </div>
      <div class="login">
        <div class="logoL">
          <img src="../../../static/images/main/loginL.png" />
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="密码登录" name="first">
            <el-form :rules="rules" :model="formData" size="small" ref="baseForm">
              <el-form-item prop="username">
                <el-input v-model="formData.username" placeholder="账户" prefix-icon="el-icon-user"></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input v-model.trim="formData.password" placeholder="密码" prefix-icon="el-icon-lock" show-password></el-input>
              </el-form-item>
              <el-form-item class="formBtn">
                <el-button type="primary" :disabled="disable" id="loginBtn" @click="login" :class="{'disable':!disable}">登录</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="验证码登录" name="second">
            <el-form :rules="rules1" :model="formData1" size="small" ref="baseForm1">
              <el-form-item prop="phone">
                <el-input v-model="formData1.phone" placeholder="手机号"></el-input>
              </el-form-item>
              <el-form-item prop="VeCode" class="veCode">
                <el-input v-model.trim="formData1.VeCode" placeholder="验证码"></el-input>
                <el-button @click="getVerificationCode" :disabled="isDisable">
                  <template v-if="!isDisable">
                    获取验证码
                  </template>
                  <template v-else>
                    {{num}}秒后重新发送
                  </template>
                </el-button>
              </el-form-item>
              <el-form-item class="formBtn">
                <el-button type="primary" :disabled="disable1" id="loginBtn" @click="login1" :class="{'disable':!disable1}">登录</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from '@/api/permission';
import { loginWithPassword, getCode, loginWithCode } from '@/api/datas';
export default {
  data () {
    return {
      activeName: 'first',
      disable: true,
      disable1: true,
      formData: {
        username: "",
        password: "",
      },
      formData1: {
        phone: "",
        VeCode: ""
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" }
        ]
      },
      rules1: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" }
        ],
      },
      num: 60,
      isDisable: false
    };
  },
  watch: {
    'formData.username' (newVal, oldVal) {
      this.formData.username = newVal.length > oldVal.length ? newVal.replace(/\s/g, '').replace(/(\d{3})(\d{0,4})(\d{0,4})/, '$1 $2 $3') : this.formData.username.trim();
      let password = this.formData.password;
      if (password != "") {
        this.disable = false;
      } else {
        this.disable = true;
      }
    },
    'formData.password' (newVal, oldVal) {
      let username = this.formData.username;
      if (username != "") {
        this.disable = false;
      } else {
        this.disable = true;
      }
    },
    'formData1.phone' (newVal, oldVal) {
      this.formData1.phone = newVal.length > oldVal.length ? newVal.replace(/\s/g, '').replace(/(\d{3})(\d{0,4})(\d{0,4})/, '$1 $2 $3') : this.formData1.phone.trim();
      let VeCode = this.formData1.VeCode;
      if (VeCode != "") {
        this.disable1 = false;
      } else {
        this.disable1 = true;
      }
    },
    'formData1.VeCode' (newVal, oldVal) {
      let phone = this.formData1.phone;
      if (phone != "") {
        this.disable1 = false;
      } else {
        this.disable1 = true;
      }
    },
  },
  methods: {
    login () {
      var _that = this;
      this.$refs["baseForm"].validate((valid) => {
        if (valid) {
          _that.disable = false;
          loginWithPassword({
            phoneNumber: _that.formData.username,
            password: _that.formData.password
          }).then(res => {
            if (res.data.code == 200) {
              let data = res.data.data;
              _that.$store.commit('LOGIN_IN', data);
              _that.$router.replace('/');
              //  window.location.href="/"
            } else {
              _that.$message.error(res.data.msg);
            }
          });
        }
      });
    },
    getVerificationCode () {
      this.$refs["baseForm1"].validate((valid) => {
        if (valid) {
          getCode({
            phoneNumber: this.formData1.phone
          })
            .then(res => {
              if (res.data.code == "200") {
                console.log(res);
                this.isDisable = true;
                this.settime();
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch(err => { });
        }
      });
    },
    settime () {
      var _that = this;
      if (this.num == 0) {
        this.isDisable = false;
        this.num = 60;
        return false;
      } else {
        this.isDisable = true;
        this.num--;
      }
      setTimeout(function () {
        _that.settime();
      }, 1000);
    },
    login1 () {
      var _that = this;
      this.$refs["baseForm1"].validate((valid) => {
        if (valid) {
          _that.disable1 = false;
          loginWithCode({
            phoneNumber: _that.formData1.phone,
            code: _that.formData1.VeCode,
          }).then(res => {
            if (res.data.code == 200) {
              let data = res.data.data;
              _that.$store.commit('LOGIN_IN', data);
              _that.$router.replace('/');
            } else {
              _that.$message.error(res.data.msg);
            }
          });
        }
      });
    },
    handleClick () {
      this.$refs["baseForm"].resetFields();
      this.$refs["baseForm1"].resetFields();
    },
    // async login () {
    //   try {
    //     let data = await login();
    //     let token = data.token;
    //     this.$store.commit('LOGIN_IN', token);
    //     this.$router.replace('/');
    //   } catch (e) {
    //     console.log(e);
    //   }
    // }
  }
}
</script>

<style scoped lang="scss">
.loginTop {
  img {
    width: 418px;
    height: auto;
  }
}
.loginMain {
  width: 997px;
  height: 538px;
  position: absolute;
  right: 50%;
  top: 50%;
  margin-right: -531px;
  margin-top: -269px;
  display: flex;
  .leftDx {
    margin-right: 76px;
    img {
      width: 520px;
      height: auto;
    }
  }
}
/deep/ .el-tabs__header {
  width: 192px;
  margin: 24px auto;
  .el-tabs__item {
    width: 96px;
    padding: 0;
    text-align: center;
  }
  .el-tabs__active-bar {
    width: 96px !important;
  }
}
/deep/ .el-icon-user:before,
/deep/ .el-icon-lock:before {
  color: #26b1f2;
}
/deep/ .el-input--small .el-input__icon {
  line-height: 40px;
}
/deep/ .el-tabs__item.is-active {
  color: #26b1f2;
}
.logoL {
  display: flex;
  justify-content: center;
  img {
    width: 174px;
    height: auto;
  }
}
.loginDiv {
  width: 100%;
  height: 100vh;
  margin: 0px;
  background: url("../../../static/images/main/loginBg.png") no-repeat;
  background-size: 100% auto;
}
.login {
  // position: absolute;
  // right: 50%;
  // top: 50%;
  width: 400px;
  height: 538px;
  background-color: #fff;
  padding: 65px 34px 128px;
  border-radius: 5px;
  // margin-right: -220px;
  // margin-top: -269px;
  h2 {
    font-size: 26px;
    text-align: center;
  }
  .tip {
    color: #888;
    font-size: 12px;
  }
  /deep/ .el-form-item--small.el-form-item {
    margin-bottom: 32px;
  }
  /deep/ .el-form-item--small .el-form-item__error {
    padding-top: 10px;
  }
  /deep/ .el-input__inner {
    width: 332px;
    height: 40px;
    line-height: 40px;
    border-radius: 8px;
    color: #333;
    border: 1px solid #d9d9d9;
  }
  /deep/ .veCode .el-form-item__content {
    display: flex;
    .el-button {
      border-radius: 8px;
    }
  }
  /deep/ .veCode .el-input__inner {
    width: 200px;
  }
  /deep/ .formBtn .el-button {
    width: 332px;
    height: 40px;
    font-size: 14px;
    color: #333;
    background: #deedfc;
    border-radius: 20px;
    width: 100%;
  }
  /deep/ .formBtn .disable {
    background: linear-gradient(180deg, #26b1f2 0%, #09cbf9 100%);
    color: #fff;
  }
  /deep/ .el-form-item__label {
    color: #aaa;
    font-size: 14px;
    font-weight: 700;
  }
}
.register {
  line-height: 30px;
  display: flex;
  color: #fff;
  margin: 0;
  padding: 0;
}
/deep/ .el-form .el-form-item .el-form-item__error {
  top: 100%;
}
.formBtn {
  margin-bottom: 0;
  margin-top: 86px;
  /deep/ .el-form-item__content {
    width: 100% !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/login/login.vue